"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconDislike = function SvgIconDislike(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "dislike icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Dislike Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4 8.375v18.75C4 28.161 4.84 29 5.875 29h6.25C13.16 29 14 28.16 14 27.125V8.375C14 7.34 13.16 6.5 12.125 6.5h-6.25C4.839 6.5 4 7.34 4 8.375zM7.125 24a1.875 1.875 0 113.75 0 1.875 1.875 0 01-3.75 0zm21.25 20c-1.577 0-2.304-3.07-2.651-4.515-.407-1.693-.827-3.443-1.984-4.602-2.536-2.54-3.867-5.779-6.962-8.837a.936.936 0 01-.278-.665V8.68a.938.938 0 01.92-.937c1.237-.023 2.867-.71 4.114-1.264C24.014 5.375 27.102 4 30.874 4h.223c3.342 0 7.294.032 8.888 2.323.656.942.816 2.112.48 3.487 1.275 1.332 1.959 3.817 1.28 5.84 1.371 1.831 1.496 4.386.728 6.209l.008.009c.93.933 1.526 2.442 1.519 3.843-.012 2.371-2.044 4.539-4.653 4.539H31.4c.571 2.214 2.6 4.073 2.6 7.387C34 43.375 30.25 44 28.375 44z"
  }));
};

var _default = SvgIconDislike;
exports.default = _default;